<template>
  <svg viewBox="0 0 1024 1024" width="20px" height="20px">
    <path d="M104.704 338.752a64 64 0 0 1 90.496 0l316.8 316.8 316.8-316.8a64 64 0 0 1 90.496 90.496L557.248 791.296a64 64 0 0 1-90.496 0L104.704 429.248a64 64 0 0 1 0-90.496z" fill="#616367" />
  </svg>
</template>

<script lang="ts" setup>
</script>
